import React from "react";
import { ImageI } from "../../../types";
import { ImageTypeEnum } from "../../../types";
import ImageSelect from "./ImageSelect";

interface ThumbnailSelectProps {
  thumbnail: ImageI | null | undefined;
  setThumbnail: (t: ImageI | null) => void;
  disabled?: boolean;
}

export default function ThumbnailSelect({
  thumbnail,
  setThumbnail,
  disabled = false,
}: ThumbnailSelectProps) {
  return (
    <ImageSelect
      imageType={ImageTypeEnum.THUMBNAIL}
      value={thumbnail}
      onChange={setThumbnail}
      disabled={disabled}
      allowClear={true}
    />
  );
}
